// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IIPItem,
}               from '../interfaces';

const getUserIPInfo = async (): Promise<IIPItem> => {
    const functions = getFunctions();
    const handleFetchIP = httpsCallable<Record<string, never>, IIPItem>(
        functions,
        'getUserIPInfo',
    );
    return handleFetchIP({})
        .then((result) => {
            const ip = result.data as IIPItem;
            return ip;
        })
        .catch((error) => {
            throw error;
        });
};

export default getUserIPInfo;
